import { Component, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MenuModule } from 'ngx-zcs-blocks';
import { MatIconModule } from '@angular/material/icon';

import { LanguageService } from '../../services/language.service';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    forwardRef(() => MenuModule),
    TranslateModule,
  ],
  selector: 'customer-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss'],
})
export class LanguageSelectorComponent {
  readonly languages = this.languagesService.languages;
  readonly currentLang$ = this.languagesService.currentLang$;

  constructor(
    readonly languagesService: LanguageService,
  ) {}
}
